import React, { useState } from "react";
import { numberToWords } from "../../helper/numberToWords";
import useOrgBenifitDataHook from "../../lib/useOrgBenifitData";
import {
  Avatar,
  Box,
  Button,
  Col,
  Divider,
  Flex,
  InputField,
  Row,
  Switchbox,
  Typography,
} from "../../ppui";
import useBenifitService from "../organization/benefit/use-benefit-service";
import { AllowanceBox, HeaderBorder } from "../style";
import { calculateTotalDeduction, convertMinutesToHours, formatIndianCurrency, getTotalearn, getTotalGross } from "./utils";

const SalaryBreakdown = ({ setUserinfo, useInfo }) => {
  const {benefitViewData}=useBenifitService()

  const [isVisible, setIsVisible] = useState(false);
  function getInitials(name) {
    const nameParts = name?.split(" ");
    const initials = nameParts
      ?.map((part) => part?.charAt(0)?.toUpperCase())
      ?.join("");
    return initials;
  }
  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState);
  };
 

  // const numberToWords = (input) => {
  //   const toWords = new ToWords();
  //   const wordRepresentation = toWords.convert(input);
  //   return wordRepresentation;
  // };
  const { benifitData } = useOrgBenifitDataHook()
  return (
    <>
      <Box Padding>
        <Row alignItem="center">
          <Col sm={"auto"}>
            <Avatar
              size="md"
              initials={getInitials(useInfo?.employee_name)}
              color={"secondary"}
              // src={leaveInfo?.employee_image}
            />
          </Col>
          <Col>
            <HeaderBorder>
              <Typography variant="h6" mb={"0"} color="primary">
                {useInfo?.employee_name} (M)
              </Typography>
              <Typography variant="body2" mb={"0"}>
                #{useInfo?.employee_code}
              </Typography>
            </HeaderBorder>
          </Col>
          <Col>
            <HeaderBorder>
              <Typography
                variant="body2"
                mb={"0"}
                color="default"
                colorVariant="light"
              >
                Department
              </Typography>
              <Typography variant="body1" mb={"0"}>
                {useInfo?.employees?.departments?.dept_name}
              </Typography>
            </HeaderBorder>
          </Col>
          <Col>
            <HeaderBorder>
              <Typography
                variant="body2"
                mb={"0"}
                color="default"
                colorVariant="light"
              >
                Designation
              </Typography>
              <Typography variant="body1" mb={"0"}>
                {useInfo?.employees?.designations?.designation_name}
              </Typography>
            </HeaderBorder>
          </Col>
          <Col>
            <Typography
              variant="body2"
              mb={"0"}
              color="default"
              colorVariant="light"
            >
              Salary Type
            </Typography>
            <Typography variant="body1" mb={"0"}>
              {useInfo?.employees?.employee_benefits[0]?.salary_type ===
              "salary"
                ? "Salaried Employee"
                : "Wages Employee"}
            </Typography>
          </Col>
        </Row>
      </Box>
      <Divider gap={20} />

      <AllowanceBox>
        <Row alignItems="center" gap={{ md: 20,}}>
          <Col sm="auto">
            <Box className="label"> Month Days</Box>
            <Box className="value"> {useInfo?.month_days}</Box>
          </Col>
          <Col sm="auto">
            <Box className="label"> Present Days</Box>
            <Box className="value">{useInfo?.monthly_attendance?.present_days}</Box>
         
          </Col>
          <Col sm="auto">
            <Box className="label"> Payable Days</Box>
            <Box className="value">{useInfo?.payable_days}</Box>
          </Col>
          <Col sm="auto">
            <Box className="label"> NCP Days</Box>
            <Box className="value">{useInfo?.ncp_days}</Box>
          </Col>
          {benifitData.ot_application ===true &&
          <Col sm="auto">
            <Box className="label"> OT Hour</Box>
            <Box className="value">{convertMinutesToHours(useInfo?.ot_hour)}</Box>
          </Col>}
          <Col sm="auto">
            <Box className="label">ESI Wages</Box>
            <Box className="value">₹ {useInfo?.esi_wages && formatIndianCurrency(Math.round(Number(useInfo?.esi_wages)))}</Box>
          </Col>
          <Col sm="auto">
            <Box className="label">EPF Wages</Box>
            <Box className="value">₹ {useInfo?.epf_wages && formatIndianCurrency(Math.round(Number(useInfo?.epf_wages)))}</Box>
          </Col>
        </Row>
      </AllowanceBox>
      {!useInfo?.is_approve && <>
      <Divider gap={20} />
      <Typography variant="body1" color="primary" fontWeight={500}>
        Salary Related Information{" "}
      </Typography>

      <Row rowGap>
        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Incentive"
            name="Incentive"
            type="number"
            suffix={"₹"}
            valueSinc
            disabled={useInfo?.is_approve||(!benefitViewData?.incentive_application)}
            value={useInfo?.incentive_amount}
            onChange={(e)=>setUserinfo({...useInfo,incentive_amount:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>
        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Bonus"
            name="Bonus"
            type="number"
            suffix={"₹"}
            valueSinc
            disabled={useInfo?.is_approve||(!benefitViewData?.bonus_status)}
            value={useInfo?.bonus_amount}
            onChange={(e)=>setUserinfo({...useInfo,bonus_amount:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>
        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Other Earnings"
            name="Other Earnings"
            type="number"
            suffix={"₹"}
            valueSinc
            disabled={useInfo?.is_approve}
            value={useInfo?.any_other_amt}
            onChange={(e)=>setUserinfo({...useInfo,any_other_amt:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>
        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Canteen Charges"
            name="Canteen"
            type="number"
            suffix={"₹"}
            valueSinc
            disabled={useInfo?.is_approve}
            value={useInfo?.canteen}
            onChange={(e)=>setUserinfo({...useInfo,canteen:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Advance Amount"
            name="Advance Amount"
            type="number"
            suffix={"₹"}
            valueSinc
            disabled={useInfo?.is_approve}
            value={useInfo?.advance_amount}
            onChange={(e)=>setUserinfo({...useInfo,advance_amount:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Loan EMI"
            name="Loan Emi"
            type="number"
            suffix={"₹"}
            valueSinc
            value={useInfo?.loan_advance}
            disabled={useInfo?.is_approve}
            onChange={(e)=>setUserinfo({...useInfo,loan_advance:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>
        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="TDS Amount"
            name="TDS Ammount"
            type="number"
            suffix={"₹"}
            valueSinc
            value={useInfo?.tds}
            disabled={useInfo?.is_approve}
            onChange={(e)=>setUserinfo({...useInfo,tds:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Other Deduction"
            name="Other Deduction"
            type="number"
            suffix={"₹"}
            valueSinc
            disabled={useInfo?.is_approve}
            value={useInfo?.any_other_deduction}
            onChange={(e)=>setUserinfo({...useInfo,any_other_deduction:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>
        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="P-TAX"
            name="PTAX"
            type="number"
            suffix={"₹"}
            valueSinc
            value={useInfo?.pTaxAmount}
            onChange={(e)=>setUserinfo({...useInfo,pTaxAmount:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Gross Arrear"
            name="Gross Arrear"
            type="number"
            suffix={"₹"}
            valueSinc
            disabled={useInfo?.is_approve}
            value={useInfo?.gross_arrear}
            onChange={(e)=>setUserinfo({...useInfo,gross_arrear:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="EPF Arrear"
            name="EPF Arrear"
            type="number"
            suffix={"₹"}
            valueSinc
            value={useInfo?.epf_arrear}
            disabled={useInfo?.is_approve}
            onChange={(e)=>setUserinfo({...useInfo,epf_arrear:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>
        <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="ESI Arrear"
            name="ESI Arrear"
            type="number"
            suffix={"₹"}
            valueSinc
            value={useInfo?.esic_arrear}
            disabled={useInfo?.is_approve}
            onChange={(e)=>setUserinfo({...useInfo,esic_arrear:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col>
        {/* <Col sm={12} md={4} lg={3}>
          <InputField
            fullWidth
            label="Canteen"
            name="Canteen"
            type="number"
            suffix={"₹"}
            valueSinc
            value={useInfo?.canteen}
            onChange={(e)=>setUserinfo({...useInfo,canteen:e?.target?.value})}
            placeholder="Type Here..."
          />
        </Col> */}
      </Row>
      </>}
      <Divider gap={20} />
      <Flex justifyContent="space-between">
        <Typography
          variant="body2"
          color="default"
          mb={"0"}
          colorVariant="light"
        >
          The breakup of salary will be:
        </Typography>
        <Button onClick={toggleVisibility} size="sm" color="primary">
          {(isVisible || useInfo?.isVisible) ? "Hide Salary breakup" : "Show Salary breakup"}
        </Button>
      </Flex>
      <Divider gap={15} />

       
      
      {/* {(isVisible || useInfo?.is_approve) && ( */}
    
      {isVisible && ( 
        <>
          <Row rowGap>
            <Col md={6}>
              <Flex direction="column" height="100%">
                <Typography
                  variant="body1"
                  color="primary"
                  mb={"0"}
                  fontWeight={500}
                >
                  Earning Part
                </Typography>
                <Divider gap={15} />
                <Flex justifyContent="space-between" gap={"10"}>
                  <Typography variant="body2">Basic Salary</Typography>
                  <Typography variant="body2">
                    {/* ₹ {useInfo?.payable_basic_salary &&  formatIndianCurrency(Math.round(Number(useInfo?.payable_basic_salary)))} */}
                    ₹ {useInfo?.payable_basic_salary &&  formatIndianCurrency(Number(useInfo?.payable_basic_salary).toFixed(2))}
                  </Typography>
                </Flex>
                {useInfo?.allowance?.filter(data => data.add_to_gross === true).map((data, key) => (
                  <Flex justifyContent="space-between" gap={10} key={key}>
                    <Typography variant="body2">
                      {data?.allowance_name}
                    </Typography>
                    {/* <Typography variant="body2">₹ {data?.allowance_value && formatIndianCurrency(Math.round(Number(data?.allowance_value)))}</Typography> */}
                    <Typography variant="body2">₹ {data?.allowance_value && formatIndianCurrency(Number(data?.allowance_value).toFixed(2))}</Typography>
                  </Flex>
                ))}
                {!useInfo?.ot_amount == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">OT Amount</Typography>
                  <Typography variant="body2">₹ {useInfo?.ot_amount && formatIndianCurrency(Number(useInfo?.ot_amount).toFixed(2))}</Typography>
                </Flex>
                }
               <Divider gap={15} />
                <Flex justifyContent="space-between" gap={"10"}>
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    
                  >
                    Gross Amount
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    
                  >
                    ₹ {formatIndianCurrency(Math.round(Number(getTotalGross(useInfo))))}
                  </Typography>
                </Flex>
                {useInfo?.allowance?.filter(data => data.add_to_gross === false).map((data, key) => (
                  <Flex justifyContent="space-between" gap={10} key={key}>
                    <Typography variant="body2">
                      {data?.allowance_name}
                    </Typography>
                    <Typography variant="body2">₹ {data?.allowance_value && formatIndianCurrency(Math.round(Number(data?.allowance_value)))}</Typography>
                  </Flex>
                ))}
                
                {!useInfo?.bonus_amount == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Bonus</Typography>
                  <Typography variant="body2">₹ {useInfo?.bonus_amount && formatIndianCurrency(Math.round(Number(useInfo?.bonus_amount)))}</Typography>
                </Flex>
                }
                {!useInfo?.incentive_amount == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Incentive</Typography>
                  <Typography variant="body2">₹ {useInfo?.incentive_amount && formatIndianCurrency(Math.round(Number(useInfo?.incentive_amount)))}</Typography>
                </Flex>
                }
                {!useInfo?.gross_arrear == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Gross Arrear</Typography>
                  <Typography variant="body2">₹ {useInfo?.gross_arrear && formatIndianCurrency(Math.round(Number(useInfo?.gross_arrear)))}</Typography>
                </Flex>
                }
                {!useInfo?.any_other_amt == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Other Earnings</Typography>
                  <Typography variant="body2">₹ {useInfo?.any_other_amt && formatIndianCurrency(Math.round(Number(useInfo?.any_other_amt)))}</Typography>
                </Flex>
                }
                <Box mt="auto" />
                <Divider gap={15} />
                <Flex justifyContent="space-between" gap={"10"}>
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    mb="0"
                  >
                    Total Earning
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    mb="0"
                  >
                    ₹ {formatIndianCurrency(Math.round(Number(getTotalearn(useInfo))))}
                  </Typography>
                </Flex>
              </Flex>
            </Col>

            <Col md={6}>
              <Flex direction="column" height="100%">
                <Typography
                  variant="body1"
                  color="primary"
                  mb={"0"}
                  fontWeight={500}
                >
                  Deduction Part
                </Typography>
                <Divider gap={15} />
                {!useInfo?.epf_amount == 0 && 
                <Flex justifyContent="space-between" gap={"10"}>
                  <Typography variant="body2">EPF Contribution</Typography>
                  <Typography variant="body2">₹ {useInfo?.epf_amount && formatIndianCurrency(Math.round(Number(useInfo?.epf_amount)))}</Typography>
                </Flex>
                }
                {!useInfo?.esi_amount == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">ESI Contribution</Typography>
                  <Typography variant="body2">₹ {useInfo?.esi_amount && formatIndianCurrency(Math.round(Number(useInfo?.esi_amount)))}</Typography>
                </Flex>
                }
                {!useInfo?.pTaxAmount == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">P-Tax</Typography>
                  <Typography variant="body2">₹ {useInfo?.pTaxAmount && formatIndianCurrency(Math.round(Number(useInfo?.pTaxAmount)))}</Typography>
                </Flex>
                }
                {!useInfo?.labour_welfare == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Labour Welfare Fund</Typography>
                  <Typography variant="body2">₹ {useInfo?.labour_welfare && formatIndianCurrency(Math.round(Number(useInfo?.labour_welfare)))}</Typography>
                </Flex>
                }
                {!useInfo?.canteen == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Canteen</Typography>
                  <Typography variant="body2">₹ {useInfo?.canteen && formatIndianCurrency(Math.round(Number(useInfo?.canteen)))}</Typography>
                </Flex>
                }
                {!useInfo?.tds == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">TDS</Typography>
                  <Typography variant="body2">₹ {useInfo?.tds && formatIndianCurrency(Math.round(Number(useInfo?.tds)))}</Typography>
                </Flex>
                }
                {!useInfo?.advance_amount == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Advance Amount</Typography>
                  <Typography variant="body2">₹ {useInfo?.advance_amount && formatIndianCurrency(Math.round(Number(useInfo?.advance_amount)))}</Typography>
                </Flex>
                }
                {!useInfo?.loan_advance == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Loan EMI</Typography>
                  <Typography variant="body2">₹ {useInfo?.loan_advance && formatIndianCurrency(Math.round(Number(useInfo?.loan_advance)))}</Typography>
                </Flex>
                }
                {!useInfo?.epf_arrear == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">EPF Arrear</Typography>
                  <Typography variant="body2">₹ {useInfo?.epf_arrear && formatIndianCurrency(Math.round(Number(useInfo?.epf_arrear)))}</Typography>
                </Flex>
                }
                {!useInfo?.esic_arrear == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">ESI Arrear</Typography>
                  <Typography variant="body2">₹ {useInfo?.esic_arrear && formatIndianCurrency(Math.round(Number(useInfo?.esic_arrear)))}</Typography>
                </Flex>
                }
                {!useInfo?.any_other_deduction == 0 && 
                <Flex justifyContent="space-between" gap={10}>
                  <Typography variant="body2">Other Deduction</Typography>
                  <Typography variant="body2">₹ {useInfo?.any_other_deduction && formatIndianCurrency(Math.round(Number(useInfo?.any_other_deduction)))}</Typography>
                </Flex>
                }
                <Box mt="auto" />
                <Divider gap={15} />
                <Flex justifyContent="space-between" gap={"10"}>
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    mb="0"
                  >
                    Total Deduction
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={500}
                    mb="0"
                  >
                    ₹ {formatIndianCurrency(Math.round(Number(calculateTotalDeduction(useInfo))))}
                  </Typography>
                </Flex>
              </Flex>
            </Col>
          </Row>
          <Divider gap={20} />
        </>
      )}
      {/* )}  */}
  

      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="body1" color="primary" fontWeight={500} mb="0">
          Net Payable Salary
        </Typography>
        <Typography variant="body1" color="primary" fontWeight={500} mb="0">
          ₹ {formatIndianCurrency(Math.round(Number(getTotalearn(useInfo)-calculateTotalDeduction(useInfo))))}
        </Typography>
      </Flex>
      <Typography variant="body2" color="default" colorVariant="light">
        In words: {numberToWords((getTotalearn(useInfo)-calculateTotalDeduction(useInfo)))}
      </Typography>

      <Divider gap={20} />
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="body1" color="primary" fontWeight={500} mb="0">
        No Work For Full Month
        </Typography>
      
      </Flex>
      <Typography variant="body2" color="default" colorVariant="light">
         <Switchbox disabled={useInfo?.is_approve}  color="Primary" name="esi_availability" size="lg" lableFirst checked={useInfo?.no_work_for_full_month} onChange={()=>setUserinfo({...useInfo,no_work_for_full_month:!useInfo?.no_work_for_full_month})} />
      </Typography>

      <Divider gap={20} />
      <InputField
        fullWidth
        label="Remarks"
        name="Remarks"
        type="text"
        value={useInfo?.remarks}
        disabled={useInfo?.is_approve}
        valueSinc={!!useInfo?.remarks}
        onChange={(e)=>setUserinfo({...useInfo,remarks:e?.target?.value})}
        placeholder="Type Here..."
      />
    </>
  );
};

export default SalaryBreakdown;
